<app-demo [datasource]="datasource" [context]="demoContext" [sources]="sources">
  <div description>
    <p>
      In case the data is accessible via some remote API, the
      <em>Datasource.get</em> could be implemented using Observable signature.
      In this demo we have a nodejs application with <em>/api/data</em> GET
      request handler ("Server" tab), which emulates a remote limited Datasource
      implementation. The Component just provides <em>/api/data</em> GET method
      call inside <em>Datasource.get</em> body. And again, the only requirement
      is that the API handler on server must return an array of index-count
      items or empty array if we are out of range.
    </p>
  </div>
</app-demo>
